import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'CreateUserButton' })(() => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 'var(--ebl-s2)',
  },
  nextButton: {
    marginLeft: 'auto',
  },
}));
